<template>
  <section class="ops-stats">
    <Breadcrumbs
      :breadcrumbs="[
        {title: $t('menu.statistics-2'), disabled: true},
        {title: $t('menu.statistics2/ops-stats'), disabled: true}
      ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :active-filters="activeFilters"
          @toggle-filters="toggleFilters"/>

        <va-popover
          placement="left"
          :message="$t('statistics2.ops_stats.downloadExcel')">
          <span class="icon i-cloud-download" @click.prevent="downloadExcelStats"></span>
        </va-popover>
      </div>
    </Breadcrumbs>

    <div class="text-center" v-if="isLoading">
      <LoadingAnimation/>
    </div>
    <div v-else>
      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <div class="col-12 col-md-3">
            <range-date-picker
              id="statistics-date-range"
              :label="$t('statistics2.hear.sublabels.period')"
              v-model="filters.dateRange"
              placeholder="---"
              :clearable="false"
              :disabled="isLoading"
            >
            </range-date-picker>
          </div>

          <div class="col-12 col-md-4">
            <label class="form-label">
              {{ $t('statistics.csm.entities') }}
            </label>
            <multiselect
              id="entities-filter"
              v-model="filters.entities"
              :options="entitiesOpts"
              track-by="id"
              :customLabel="formatedEntityLabel"
              :placeholder="entitiesOpts.length ? $t('clinical.waiting_room_statistics.several_entities') : $t('clinical.waiting_room_statistics.no_entities')"
              :allow-empty="true"
              :multiple="true"
              :internal-search="true"
              :disabled="!entitiesOpts.length || isLoading"
            >

              <template slot="clear">
            <span class="multiselect__clear" v-if="filters.entities.length"
                  @mousedown.prevent.stop="filters.entities = []"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <div>
        <va-tabs v-model="tabValue" style="border-width: 2px">
          <va-tab
            v-for="year in tabYears"
            :key="year"
          >
            {{ year }}
          </va-tab>
        </va-tabs>
        <div class="table-placeholder">
          <div class="col-12" v-if="totalsData !== null">
            <br/>
            <br/>
            <h4>{{$t('statistics2.ops_stats.totals')}}</h4>
            <div class="row">
              <va-card v-for="key in Object.keys(totalsData)" class="info-widget mr-4 text-center" style="width:10%;">
            <span
              class="kpi-content">  {{ totalsData[key] }} </span>
                <p>
                  <span class="kpi-description">  {{ $t(`statistics2.ops_stats.columns.${key}`) }} </span>
                </p>
              </va-card>
            </div>
          </div>
          <div class="col-12">
            <v-client-table
              id="opsStatsTable"
              ref="opsStatsTable"
              name="opsStatsTable"
              :data="shownStatsData"
              :columns="opsStatsTableColumns"
              :options="tableOptions">

              <span slot="entity.qualitative" slot-scope="props">
                {{$t(`statistics2.ops_stats.columns.qualitatives.${props.row.entity.qualitative}`)}}
             </span>
              <span slot="entity.entityStatus" slot-scope="props">
                {{$t(`statistics2.ops_stats.columns.statuses.${props.row.entity.entityStatus}`)}}
             </span>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Filters from '@/components/common/Filters'
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
import RangeDatePicker from "@/components/common/RangeDatePicker";
import {Statistics2Service} from "@/api/StatisticsService";
import {get as _get} from "lodash";
import {ClientTable} from 'vue-tables-2'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {STATISTICS2_OPS_STATS} from "@/local-storage/LocalStorageKeys";
import Vue from "vue";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation.vue";
import {EntityService} from "@/api/AuthService";
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import Multiselect from 'vue-multiselect'

Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  components: {
    LoadingAnimation,
    Breadcrumbs,
    Filters,
    RangeDatePicker,
    Multiselect
  },
  mixins: [MultiselectLabelFormatter],
  data() {
    return {
      isLoading: false,
      hasLoadedLocalStorage: false,
      isExportingExcelToast: null,
      showFilters: true,
      activeFilters: 0,
      entitiesOpts: [],
      filters: {
        entities: [],
        dateRange: {
          start: this.moment().startOf('year').format('YYYY-MM-DD'),
          end: this.moment().endOf('month').format('YYYY-MM-DD'),
        }
      },
      statsData: null,
      tabYears: [],
      tabValue: 0,
      shownStatsData: [],
      totalsData: null,
      opsStatsTableColumns: ['entity.name', 'entity.businessPlan', 'entity.entityStatus', 'entity.qualitative', 'entity.flow', 'screenings', 'appointments', 'leads', 'lq', 'lqByScreenings',  'consultas', 'lqe', 'orl', 'experience', 'salesCount', 'salesValue'],
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns_dropdown')
        },

        headings: {
          'entity.name': this.$t('statistics2.ops_stats.columns.entityName'),
          'entity.businessPlan': this.$t('statistics2.ops_stats.columns.businessPlan'),
          'entity.entityStatus': this.$t('statistics2.ops_stats.columns.entityStatus'),
          'entity.qualitative': this.$t('statistics2.ops_stats.columns.qualitative'),
          'entity.flow': this.$t('statistics2.ops_stats.columns.flow'),
          'entity.parsedClustersStr': this.$t('statistics2.ops_stats.columns.parsedClustersStr'),
          'lq': this.$t('statistics2.ops_stats.columns.lq'),
          'lqe': this.$t('statistics2.ops_stats.columns.lqe'),
          'screenings': this.$t('statistics2.ops_stats.columns.screenings'),
          'lqByScreenings': this.$t('statistics2.ops_stats.columns.lqByScreenings'),
          'appointments': this.$t('statistics2.ops_stats.columns.appointments'),
          'consultas': this.$t('statistics2.ops_stats.columns.consultas'),
          'orl': this.$t('statistics2.ops_stats.columns.orl'),
          'experience': this.$t('statistics2.ops_stats.columns.experience'),
          'salesValue': this.$t('statistics2.ops_stats.columns.salesValue'),
          'salesCount': this.$t('statistics2.ops_stats.columns.salesCount')
        },
        columnsClasses: {
          day: 'column-center',
          period: 'column-center',
          homologousPeriod: 'column-center'
        },
        skin: 'table table-striped table-hover is-fullwidth',
        columnsDropdown: false,
        filterable: false,
        sortable: ['entity.name', 'entity.businessPlan', 'entity.entityStatus', 'entity.qualitative', 'entity.flow', 'leads', 'lq', 'lqe', 'screenings', 'lqByScreenings', 'appointments', 'consultas', 'orl', 'experience', 'salesValue', 'salesCount'],
      },

    }
  },
  async mounted() {
    this.entitiesOpts = await EntityService.getOpsSatsData()
    await this.loadLocalStorage()
    //await this.getStatsData();
  },
  methods: {
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    getStatsData: function () {
      return new Promise(async (resolve, reject) => {
        this.isLoading = true
        try {
          let params = this.getActiveFilters()
          this.statsData = await Statistics2Service.getOpsStatsData(params)
          this.tabYears = this.statsData.map(elem => elem.year);
          this.tabValue = 0
          this.shownStatsData = this.statsData[0].data
          this.totalsData = this.statsData[this.tabValue].totals
        } catch (e) {
          console.log(e)
          this.showToast(this.$t('clinical.waiting_room_statistics.something_went_wrong'), this.$store.state.errorToastOptions)
          reject(e)
        } finally {
          this.isLoading = false;
        }
      })
    },
    downloadExcelStats: function () {
      let params = this.getActiveFilters()
      this.isExportingExcelToast = this.showToast(this.$t('statistics2.ops_stats.exportingExcel'), {
        ...this.$store.state.successToastOptions,
        icon: 'cloud-download',
        duration: null
      })
      Statistics2Service.downloadOpsExcel(params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ops-stats.xlsx');
        document.body.appendChild(link);
        link.click();
        this.isExportingExcelToast.goAway(100)
      }).catch(err => {
        console.log(err)
        this.isExportingExcelToast.goAway(100)
        setTimeout(() => {
          this.showToast(this.$t('statistics2.ops_stats.downloadExcelGenericFailure'), this.$store.state.errorToastOptions)
        }, 500)
      }).finally(() => {
        this.isExportingExcelToast = null
      })
    },
    getActiveFilters: function () {
      let entities = null
      if(this.filters.entities.length) {
        entities = this.filters.entities.map(entity => entity.id).join(',')
      }
      let filters = {
        start: _get(this.filters, 'dateRange.start', this.moment().startOf('year').format('YYYY-MM-DD')) || undefined,
        end: _get(this.filters, 'dateRange.end', this.moment().endOf('month').format('YYYY-MM-DD')) || undefined,
      }
      if(entities) {
        filters.entities = entities
      }

      return filters;
    },
    loadLocalStorage: async function () {
      const state = LocalStorageHelper.get(STATISTICS2_OPS_STATS)
      if (state) {
        // s date filters from local storage
        if (state.start && state.start !== '' && state.end && state.end !== '') {
          this.filters.dateRange.start = state.start
          this.filters.dateRange.end = state.end
        }
        if (state.entities) {
          const entitiesIds = state.entities.split(',').map(elem => parseInt(elem))
          this.filters.entities = this.entitiesOpts.filter(entity => entitiesIds.includes(entity.id))
        }
      } else {
        this.saveLocalStorage()
      }
      this.hasLoadedLocalStorage = true
      await this.getStatsData()
    },
    saveLocalStorage: function () {
      LocalStorageHelper.set(STATISTICS2_OPS_STATS, {
        ...this.getActiveFilters(),
      })
      this.hasLoadedLocalStorage = true
    },
  },
  watch: {
    'filters.dateRange': {
      handler: async function () {
        if (this.hasLoadedLocalStorage && !this.isLoading) {
          this.isLoading = true
          await this.saveLocalStorage()
          await this.getStatsData()
        }
      },
      deep: true,
      immediate: true
    },
    tabValue: {
      handler: function (value) {
        this.shownStatsData = this.statsData[value].data
        this.totalsData = this.statsData[value].totals
      },
    },
    'filters.entities': {
      handler: async function(val) {
        if (this.hasLoadedLocalStorage &&!this.isLoading && val !== null) {
          console.log("HERE")
          this.isLoading = true
          await this.saveLocalStorage()
          await this.getStatsData()
        }
      }
    }
  }
}
</script>
<style lang="scss">
#opsStatsTable {

  .number-widget {
    background: #f0f0f0;
    border-radius: 0.375rem;
    padding: 2rem 1rem;

    h2 {
      color: $evollu-gray-light;
    }
  }

  .table-bordered th {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 2px solid #cecece;
  }

  .table-bordered td {
    border: 0 !important;
  }

  .column-center {
    text-align: center;
  }
}

table.totalsTable {
  text-align: center;
  border-collapse: collapse;
}
table.totalsTable th {
  font-weight: bold;
}
table.totalsTable td, table.totalsTable th {
  padding: 5px 10px;
}
table.totalsTable th {
  background: rgba(0, 157, 119, 0.55);
}

table.totalsTable td{
  background: rgba(0, 157, 119, 0.35);
}
</style>
